export const groupByOrderNoAndSortByMiningQuantity = (data, orderNo, id) => {
  const result = data
    .reduce((groups, item) => {
      let group = groups.find((group) => group.orderNo === item.orderNo);
      if (!group) {
        groups.push({ orderNo: item.orderNo, items: [item] });
      } else {
        group.items.push(item);
      }
      return groups;
    }, [])
    .map((group) => ({
      ...group,
      items: group.items
        .filter((item) => item.isInUse)
        .sort((a, b) => a.miningQuantity - b.miningQuantity),
    }))
    .sort(
      (a, b) =>
        b.items.reduce((total, item) => total + item.miningQuantity, 0) -
        a.items.reduce((total, item) => total + item.miningQuantity, 0),
    )
    .sort((a, b) => a.orderNo - b.orderNo);

  if (orderNo && id) {
    result.forEach((group) => {
      if (group.orderNo === orderNo) {
        group.items = [
          ...group.items.filter((item) => item.id === id),
          ...group.items.filter((item) => item.id !== id),
        ];
      }
    });
  }
  return result;
};

export const groupByOrderNoAndSortByMiningQuantityandId = (data, orderId, id) => {
  return data?.map((group) => {
    if (group.orderNo === orderId) {
      group.items = [
        ...group.items.filter((item) => item.batch === id),
        ...group.items.filter((item) => item.batch !== id),
      ];
    }
    return group;
  });
};

const byMiningQuantityAsc = (a, b) => a.miningQuantity - b.miningQuantity;

const matchCard = (card, updated) => card.assetId === updated.assetId && String(card.batch) === String(updated.batch);

export const upsertCardUpdate = (groups, updated) => {
  const existsInGroup = groups.some((group) => group.items.some((card) => matchCard(card, updated)));
  if (!existsInGroup && updated.isInUse) {
    const groupIndex = groups.findIndex((group) => group.orderNo === updated.orderNo);
    const newGroups =
      groupIndex === -1
        ? [...groups, { orderNo: updated.orderNo, items: [updated] }]
        : groups.map((group, i) =>
            i !== groupIndex
              ? group
              : { ...group, items: [...group.items, updated].sort(byMiningQuantityAsc) },
          );
    return [...newGroups].sort((a, b) => a.orderNo - b.orderNo);
  }
  return groups.map((group) => ({
    ...group,
    items: group.items.map((card) => (matchCard(card, updated) ? { ...card, ...updated } : card)),
  }));
};

export const upsertAllItemsUpdate = (items, updated) => {
  const exists = items.some((card) => matchCard(card, updated));
  if (!exists && updated.isInUse) {
    return [...items, updated].sort(byMiningQuantityAsc);
  }
  return items.map((card) => (matchCard(card, updated) ? { ...card, ...updated } : card));
};

export const upsertCraftedCard = (groups, updated) => {
  const groupIndex = groups.findIndex((group) => group.orderNo === updated.orderNo);
  const newGroups =
    groupIndex === -1
      ? [...groups, { orderNo: updated.orderNo, items: [updated] }]
      : groups.map((group, i) => {
          if (i !== groupIndex) return group;
          const exists = group.items.some((card) => matchCard(card, updated));
          const newItems = exists
            ? group.items.map((card) => (matchCard(card, updated) ? { ...card, ...updated } : card))
            : [...group.items, updated];
          return { ...group, items: [...newItems].sort(byMiningQuantityAsc) };
        });
  return [...newGroups].sort((a, b) => a.orderNo - b.orderNo);
};

export const upsertAllItemsCrafted = (items, updated) => {
  const exists = items.some((card) => matchCard(card, updated));
  if (exists) {
    return items.map((card) => (matchCard(card, updated) ? { ...card, ...updated } : card));
  }
  return [...items, updated].sort(byMiningQuantityAsc);
};
